import React from 'react'

// Hooks
import { useGlobal } from '../../../../../hooks'

import AdministrationInfo from '../..'

// Queries
import { READ_CHANGE_MOTIVES, DELETE_CHANGE_MOTIVES } from './queries'

const AdministrationInfoComponentChangeMotives = ({ ...rest }) => {
  const [{ me }] = useGlobal()

  const no = ![1, 2].includes(me.id_role)

  return (
    <AdministrationInfo
      queries={{ read: READ_CHANGE_MOTIVES, delete: DELETE_CHANGE_MOTIVES }}
      title="Motivo de cambio"
      {...rest}
      noDuplicate={no}
      noUpdate={no}
      noDelete={no}
    />
  )
}

export default AdministrationInfoComponentChangeMotives
